import { render, staticRenderFns } from "./AudiencePortrait.vue?vue&type=template&id=1f803519&scoped=true&"
import script from "./AudiencePortrait.vue?vue&type=script&lang=js&"
export * from "./AudiencePortrait.vue?vue&type=script&lang=js&"
import style0 from "./AudiencePortrait.vue?vue&type=style&index=0&id=1f803519&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f803519",
  null
  
)

export default component.exports